import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from '../Title/Title'

import Products from "../../components/Products";

import { fetchBestSelllingProd } from "../../apiCalls/product";

const BestSelling = () => {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.products.bestSelling);

  console.log(productList, 'trend lsdfjhdfb')

  useEffect(() => {
    fetchBestSelllingProd(dispatch);
  }, [dispatch]);
  
  return (
    <>
        <section className='new-products'>
            <Title title="Best Selling" />
                <Products products={productList} />
        </section>
    </>
  )
}

export default BestSelling